import TerminalIcon from '@mui/icons-material/Terminal';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography} from '@mui/material';
import {PgHistoryAgentEvent} from '_logics/LFCSourceUtil';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

type AgentToolEvent = Extract<PgHistoryAgentEvent, {type: 'tool'}>;

type Props = {
  events: AgentToolEvent[];
  isActive: boolean;
};

const AgentToolLog = ({events, isActive}: Props) => {
  const {t} = useTranslation();
  const [expanded, setExpanded] = useState(isActive);

  useEffect(() => {
    setExpanded(isActive);
  }, [isActive]);

  if (events.length === 0) return null;

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, nextExpanded) => setExpanded(nextExpanded)}
      disableGutters
      elevation={0}
      sx={{borderTop: 1, borderColor: 'divider', bgcolor: 'transparent'}}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{minHeight: 36, px: 2}}>
        <Typography variant="caption" color="text.secondary">
          {t('実行ログ')} ({events.length})
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{px: 2, py: 0.5}}>
        {events.map((event, index) => (
          <Box key={`${event.label}-${index}`} sx={{display: 'flex', gap: 1, py: 0.5}}>
            <TerminalIcon fontSize="small" color="action" />
            <Box sx={{minWidth: 0}}>
              <Typography variant="caption" color="text.secondary" sx={{wordBreak: 'break-all'}}>
                {event.label}
              </Typography>
              {event.command && (
                <Typography
                  component="pre"
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    m: 0,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                    fontFamily: 'monospace'
                  }}
                >
                  {event.command}
                </Typography>
              )}
            </Box>
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default AgentToolLog;
